export default __webpack_public_path__ + "38c3d6712735d082976f5ddac8810e5a.svg";